import {
    getCategories,
    deleteCategory,
    getShowCategory,
    updateCategory,
    createCategory
} from '../../api/categoryApi'
import {Message} from "element-ui";
import router from "../../router";

const state = {
    categories: [],
    category: {}
}

const getters = {
    getCategories: state => state.categories,
    getShowCategory: state => state.category
}

const mutations = {
    SET_CATEGORIES: (state, payload) => {
        state.categories = payload.data
    },
    SET_CATEGORY_SHOW: (state, payload) => {
        state.category = payload
    },
}

const actions = {
    getCategories: ({commit}, params) => {
        getCategories(params).then(resp => {
            commit('SET_CATEGORIES', resp)
        }).catch(err => console.log(err))
    },
    deleteCategory: ({dispatch}, id) => {
        deleteCategory(id).then(r => {
            Message({
                message: 'Category has been deleted',
                type: 'success',
                duration: 5 * 1000,
                showClose: true,
            })
        })
    },
    getShowCategory: ({commit, dispatch}, idCategory) => {
        getShowCategory(idCategory).then(r => {
            commit('SET_CATEGORY_SHOW', r.data)
        }).catch(err => {
            if (err.response.status === 404) {
                console.log(router.push({name: 'not-found'}))
            }
        })
    },
    updateCategory: ({commit}, payload) => {
        updateCategory(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    createCategory: ({commit}, payload) => {
        createCategory(payload).then(r => {
        Message({
            message: 'Data saved',
            type: 'success',
            duration: 5 * 1000,
        })
        }).catch(err => console.dir(err))
    },
    clearCurrentCategory: ({commit}) => {
        commit('SET_CATEGORY_SHOW', { logo_name: '' } )
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
